import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getData } from '../../../utils/fetch';

export const getDataNews = createAsyncThunk("news/getData", async (args, { rejectWithValue }) => {
    try {
        const result = await getData(`/cms/news`);
        return result.data.data;
    } catch (error) {
        rejectWithValue(error.response.data);
    }
})

const newsSlice = createSlice({
    name: "news",
    initialState: {
        data: [],
        page: 1,
        limit: 10,
        status: 'idle',
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getDataNews.pending, (state, action) => {
            state.status = 'loading';
        })
            .addCase(getDataNews.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(getDataNews.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
    }
});

export default newsSlice.reducer;